const SettingDefaultAddressViewItem = ({ rootStore, obj }) => {
  return (
    <li>
      <strong>{obj.addr}</strong>
      <button
        className="btn_delete"
        onClick={event => {
          document.getElementById("quickAddr").value = obj.seq;
          rootStore.layerStore.setLayerAlertType("quickAddr_delete_confirm");
          rootStore.layerStore.setLayerAlertView(true);
        }}
      >
        <span>삭제</span>
      </button>
    </li>
  );
};

export default SettingDefaultAddressViewItem;
